import { useEffect, useRef } from 'react';
import { getStoredToken } from './api';

// Live WebSocket hook
export function useRealtime(restaurantId, onMessage) {
    const wsRef = useRef(null);

    useEffect(() => {
        if (!restaurantId) return;
        const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
        const base = process.env.REACT_APP_BACKEND_URL.replace(/^https?:\/\//, '');
        const token = getStoredToken();
        const qs = token ? `?token=${encodeURIComponent(token)}` : '';
        const url = `${proto}://${base}/api/ws/${restaurantId}${qs}`;
        let mounted = true;
        let retryDelay = 1000;

        function connect() {
            const ws = new WebSocket(url);
            wsRef.current = ws;
            ws.onopen = () => { retryDelay = 1000; };
            ws.onmessage = (ev) => {
                try {
                    const msg = JSON.parse(ev.data);
                    onMessage && onMessage(msg);
                } catch {}
            };
            ws.onclose = () => {
                if (!mounted) return;
                setTimeout(connect, retryDelay);
                retryDelay = Math.min(retryDelay * 2, 10000);
            };
            ws.onerror = () => { try { ws.close(); } catch {} };
        }
        connect();
        return () => { mounted = false; try { wsRef.current?.close(); } catch {} };
    }, [restaurantId, onMessage]);
}
